module.exports = __webpack_public_path__ + "media/images/subject_img/LAND ECONOMY-75f9afb4f4a84e73c6bcf5976696eeee.jpg";